/**
 * Helper to attach a callback to an observable and get a cancel function back instead of having to call unsubscribe.
 * Useful for when you don’t want to keep holding a reference to either the observable or the callback.
 * This way you only have to keep one reference (to the returned cancel function) instead of two.
 *
 * @param observable the observable to subscribe to
 * @param cb the emit callback to register
 * @returns a cancel function to call when the subscription should stop
 */
export function asCancelable(observable, cb) {
    observable.subscribe(cb);
    return function cancel() {
        observable.unsubscribe(cb);
    };
}
